export const isAnEmptyObjectArray = (array: any[]) => {
  return array.length && Object.keys(array[0]).length;
};

export const isEmpty = (value: any) => {
  return value == undefined || value == null || value == "";
};

export const isNotEmpty = (value: any) => {
  return !isEmpty(value);
};
export const isNotEmptyOrZero = (value: any) => {
  return value || value === 0;
};

export const isEmptyObject = (obj: any) => {
  if (obj.constructor != Object) return isEmpty(obj);
  return Object.keys(obj).length === 0 && typeof obj === "object";
};

export function isValidObject(obj: any) {
  //check if variable is object
  if (typeof obj !== "object") {
    return isNotEmpty(obj);
  }
  for (let key in obj) {
    if (obj[key] == null) {
      return false;
    }
  }
  return true;
}

// const ITEM_PER_PAGE_CONSTANT = "itemsPerPage";
const PAGE_CONSTANT = "page";

export const removeFilterNotUsableForExport = (params: any) => {
  let newData = {};
  for (const [key, value] of Object.entries(params)) {
    if (
      // key !== ITEM_PER_PAGE_CONSTANT &&
      key !== PAGE_CONSTANT &&
      (value || value === false || value === 0)
    ) {
      newData = {
        ...newData,
        [key]: typeof value === "string" ? value.trim() : value,
      };
    }
  }
  return newData;
};
